import { jsx as _jsx } from "react/jsx-runtime";
import { NUM_ROWS_OF_SWATCHES, SWATCH_WIDTH } from "@faire/retailer-visitor-shared/views/product/ProductDetails/AddToCart/OptionSelection/SpecialOptionPicker";
import { SpecialOptionVariation } from "@faire/retailer-visitor-shared/views/product/ProductDetails/AddToCart/OptionSelection/SpecialOptionVariation";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { trackProductInfoProductDetailsVariantSelectionClick } from "@faire/web-api--source/events/productInfo/click/productDetailsVariantSelection";
import { observer } from "mobx-react";
import React, { useCallback } from "react";
var SWATCH_ROW_TABLET_WIDTH = 300;
var SWATCH_ROW_DEFAULT_WIDTH = 360;
var OptionVariationBase = function(param) {
    var productVariation = param.productVariation, viewState = param.viewState, variationDisplayType = param.variationDisplayType, variationName = param.variationName, index = param.index, hoveredValue = param.hoveredValue, setHoveredValue = param.setHoveredValue, alt = param.alt, showAllSwatches = param.showAllSwatches;
    var _viewState_product_purchase_information, _variationMap_entries_find_entry_values_find_image, _variationMap_entries_find_entry_values_find, _variationMap_entries_find_entry_values, _variationMap_entries_find;
    var outOfStock = viewState.isVariationOutOfStock(productVariation);
    var productOption = viewState.optionForAlternateVariation(productVariation);
    var unavailable = !productOption;
    var selectedVariationValue = viewState.getSelectedVariationValue(variationName);
    var handleVariationClick = useCallback(function() {
        trackProductInfoProductDetailsVariantSelectionClick(variationDisplayType.toString());
        viewState.handleVariationSelect(variationName, productVariation.value);
    }, [
        productVariation.value,
        variationDisplayType,
        variationName,
        viewState
    ]);
    var variationMap = (_viewState_product_purchase_information = viewState.product.purchase_information) === null || _viewState_product_purchase_information === void 0 ? void 0 : _viewState_product_purchase_information.variation_map;
    var isTablet = useViewport().isTablet;
    var numSwatchesPerRow = Math.floor((isTablet ? SWATCH_ROW_TABLET_WIDTH : SWATCH_ROW_DEFAULT_WIDTH) / SWATCH_WIDTH);
    if (productVariation.value === undefined) {
        return null;
    }
    return /*#__PURE__*/ _jsx(SpecialOptionVariation, {
        onVariationClick: handleVariationClick,
        variationValue: productVariation.value,
        outOfStock: outOfStock,
        unavailable: unavailable,
        productOption: productOption,
        selected: selectedVariationValue === productVariation.value,
        displayType: variationDisplayType,
        hovered: hoveredValue === productVariation.value,
        setHoveredValue: setHoveredValue,
        alt: alt,
        imageUrl: variationMap === null || variationMap === void 0 ? void 0 : (_variationMap_entries_find = variationMap.entries.find(function(entry) {
            return entry.name === variationName;
        })) === null || _variationMap_entries_find === void 0 ? void 0 : (_variationMap_entries_find_entry_values = _variationMap_entries_find.entry_values) === null || _variationMap_entries_find_entry_values === void 0 ? void 0 : (_variationMap_entries_find_entry_values_find = _variationMap_entries_find_entry_values.find(function(entryValue) {
            return entryValue.value === productVariation.value;
        })) === null || _variationMap_entries_find_entry_values_find === void 0 ? void 0 : (_variationMap_entries_find_entry_values_find_image = _variationMap_entries_find_entry_values_find.image) === null || _variationMap_entries_find_entry_values_find_image === void 0 ? void 0 : _variationMap_entries_find_entry_values_find_image.url,
        isHidden: !showAllSwatches && index >= NUM_ROWS_OF_SWATCHES * numSwatchesPerRow
    }, productVariation.value);
};
export var OptionVariation = observer(OptionVariationBase);
